export default __webpack_public_path__ + "static/media/discipline-business.9d0f0253.svg";